<template>
  <b-card-actions class="card business-card" title="مهامي">
    <!----><!---->
    
    <div class="card-body">
      <div class="business-items" v-if="items.length > 0">
        <div v-for="item in items" :key="item.id">
          <div class="business-item" v-if="item.done == '0'">
            <div class="d-flex align-items-center justify-content-between">
              <div class="custom-control custom-checkbox">
                <b-form-checkbox
                  v-model="item.done"
                  value="1"
                  @input="toggleStatus(item)"
                >
                  {{ item.title }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->

      <button
        type="button"
        class="btn btn-primary btn-block"
        v-b-modal.modal-login
      >
        إضافه
      </button>
    </div>

    <!----><!---->
    <b-modal
      id="modal-login"
      cancel-variant="outline-secondary"
      ok-title="إضافه"
      cancel-title="Close"
      centered
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      title="إضافه"
    >
      <b-form>
        <b-form-group>
          <label for="title">عنوان :</label>
          <b-form-input type="text" placeholder="عنوان" v-model="title" />
        </b-form-group>
      </b-form>
    </b-modal>
  </b-card-actions>
</template>

<script>
import controller from "@/Controllers/ToDoController";
let ctr = new controller();
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
export default {
  components: {
    BCardActions,
  },
  props: {
    items: [],
    title: "",
  },

  methods: {
    async toggleStatus(item) {
       await ctr.ToggleStatus(item.id);
      //    this.items =  await ctr.GetAll();
    },
    resetModal() {
      this.title = "";
    },
    async handleOk() {
      await ctr.Insert({ title: this.title });
      this.items = await ctr.GetAll();
      //
    },
  },
};
</script>

<style>
</style>
